import React, { useState } from 'react';
import '../Components/Styles/pages/Gallery_1.css';
import heroBanner from '../Asserts/choose_bg.png';
import galimg1 from "../Asserts/gallery3.jpg";
import Footer from "../Components/Component/Footer";
import { useNavigate } from 'react-router-dom'; 

const Gallery_3 = () => {

  const [sortBy, setSortBy] = useState('Most recent'); // (Optional) You can remove this if not needed
  const navigate = useNavigate(); // Navigation hook

  return (
    <div className="gallery-page">

      {/* ================== HERO SECTION ================== */}
      <div
        className="gallery-hero"
        style={{ backgroundImage: `url(${heroBanner})` }}
      >
        <div className="gallery-hero-overlay">
          <h1 className="gallery-hero-title">
            We make impact to your business with our quality
            <br />
            <span className="gallery-hero-subtitle">
               
            </span>
          </h1>
        </div>
      </div>

      {/* ================== MAIN IMAGE SECTION ================== */}
      <div className="gallery-image-section">
        <img src={galimg1} alt="Gallery Visual" className="gallery-main-image" />
      </div>

      {/* ================== BACK BUTTON ================== */}
      <div className="back-to-blog-container">
        <button className="back-to-blog-btn" onClick={() => navigate('/Gallery')}>
          ← Back to Gallery
        </button>
      </div>

      <Footer />
    </div>
  );
};

export default Gallery_3;
